import { s, c } from '../../val.config';
import {
  doubleImageElementNewSchema,
  doubleImageElementSchema,
  imageCarouselElement,
  linkListsElementSchema,
  linksElementSchema,
  singleImageElementSchema,
  textAndImageElementSchema,
  textElementSchema,
} from '../schema/pageElements.val';
import { pageMetadataSchema } from '../schema/pageMetadata.val';

export const schema = s.object({
  header: s.string(),
  ingress: s.richtext({
    style: {
      bold: true,
      italic: true,
      lineThrough: true,
    },
    block: {
      h1: false,
      h2: false,
      h3: true,
      h4: true,
      h5: true,
      h6: true,
      ul: true,
      ol: true,
    },
    inline: {
      a: true,
      img: true,
    },
  }),
  subheader: s.string(),
  pageImage: s.image(),
  contactLink: s.object({
    text: s.string(),
    href: s.string(),
  }),
  pageElements: s.array(
    s.union(
      'type',
      textElementSchema,
      singleImageElementSchema,
      textAndImageElementSchema,
      doubleImageElementSchema,
      doubleImageElementNewSchema,
      linksElementSchema,
      linkListsElementSchema,
      imageCarouselElement
    )
  ),
  pageMetadata: pageMetadataSchema,
});

export default c.define('/content/pages/tjenester.val.ts', schema, {
  header: 'Tjenester',
  ingress: [
    {
      tag: 'p',
      children: [
        'Blank leverer design- og utviklingstjenester til startups og etablerte virksomheter. Vi bygger produkter fra grunnen av og tar ansvar for hele prosessen: fra idé til lansering, videreutvikling og skalering.',
      ],
    },
    {
      tag: 'p',
      children: [
        'Med Blank får du en partner som leverer løsninger som er både brukervennlige og teknisk solide. For oss handler det om å skape verdi fra første dag og fortsette å gjøre det over tid.',
      ],
    },
  ],
  subheader: 'Vi gjør idéer til produkter',
  pageImage: c.image('/public/val/dsc07886-enhanced-nr_1d49b.jpg', {
    width: 3457,
    height: 2286,
    mimeType: 'image/jpeg',
    alt: 'Ole Jacob holder foredrag',
    hotspot: { x: 0.5463215258855586, y: 0.3141951164550035 },
  }),
  contactLink: {
    text: 'La oss ta en prat',
    href: '/prosjektprat',
  },
  pageElements: [
    {
      type: 'linkListsElement',
      lists: [
        {
          title: 'Design',
          items: [
            { text: 'Idéutvikling' },
            { text: 'Innsikt og analyse' },
            { text: 'Tjenestedesign' },
            { text: 'Merkevare' },
            { text: 'UX og UI' },
            { text: 'Designsystem' },
            { text: 'Universell utforming' },
          ],
        },
        {
          title: 'Teknologi',
          items: [
            { text: 'Frontend-utvikling' },
            { text: 'Backend-utvikling' },
            { text: 'App-utvikling' },
            { text: 'Skytjenester' },
            { text: 'Kunstig intelligens' },
            { text: 'Arkitektur' },
          ],
        },
        {
          title: 'Strategi og ledelse',
          items: [
            { text: 'Smidig metodikk' },
            { text: 'Digital transformasjon' },
            { text: 'Innovasjonsprosesser' },
            { text: 'Produktstrategi' },
            { text: 'Prosjektledelse' },
            { text: 'Produktledelse' },
          ],
        },
      ],
    },
    {
      type: 'doubleImageElementNew',
      centered: false,
      layout: 'tall-square',
      image1: c.image(
        '/public/val/e7cada63f259fdc4fbf6e4befa4f493d_4f277.jpg',
        {
          width: 2731,
          height: 4096,
          mimeType: 'image/jpeg',
          hotspot: { x: 0.55858310626703, y: 0.428 },
        }
      ),
      image2: c.image('/public/val/img_7133_a57fd.jpg', {
        width: 1366,
        height: 2048,
        mimeType: 'image/jpeg',
        hotspot: { x: 0.5040871934604905, y: 0.428 },
      }),
      text: 'Vi har valgt å være et lite og spesialisert fagmiljø. Hos oss jobber designere og utviklere som er blant de aller dyktigste i bransjen. Vi stiller høye krav til kompetanse og evne til å samarbeide tett med kunder. Kvalitet i hver eneste leveranse er vårt felles ansvar.',
    },
    {
      type: 'textElement',
      text: [
        {
          tag: 'h4',
          children: ['Vi jobber smidig både i og utenfor prosjektet'],
        },
        {
          tag: 'p',
          children: [
            'Vi tror på korte beslutningsveier, raske tilbakemeldinger og kontinuerlig levering. Derfor tester vi tidlig fremfor å planlegge alt ihjel. Vi bryter ned komplekse problemer til håndterbare deler og lanserer heller noe som virker enn å vente på noe som er perfekt.',
          ],
        },
        { tag: 'h4', children: ['Vi tenker langsiktig'] },
        {
          tag: 'p',
          children: [
            'Over halvparten av kundene våre har vi jobbet med i mer enn fem år. Og noen helt siden oppstarten i 2015. Vi fokuserer på å lære våre kunder å kjenne , på å bygge tillit og skape verdi over tid.',
          ],
        },
        { tag: 'h4', children: ['Vi forstår forretning, ikke bare teknologi'] },
        {
          tag: 'p',
          children: [
            'Vi er spesialister og håndverkere, men vi ser forbi koden og designet og har også fokus på de forretningsmessige målene bak prosjektene dine. Dette gjør at vi kan ta smartere valg og skape løsninger som  bidrar til din bunnlinje.',
          ],
        },
      ],
      title: 'Vår filosofi',
    },
    {
      type: 'singleImageElement',
      clickable: false,
      keepAspectRatio: false,
      image: c.image(
        '/public/val/images/3064b5e40967f1d1bea1d8dd95efa41ca26c96b0-1920x1281.webp',
        {
          width: 1920,
          height: 1281,
          mimeType: 'image/webp',
          hotspot: { x: 0.5066666666666667, y: 0.17486338797814208 },
        }
      ),
    },
    {
      type: 'textElement',
      text: [
        { tag: 'h4', children: ['Forstå'] },
        {
          tag: 'p',
          children: [
            'Vi starter med å lytte og lære om utfordringene dine og brukernes behov.',
          ],
        },
        { tag: 'h4', children: ['Skape'] },
        {
          tag: 'p',
          children: [
            'Vi utforsker idéer, bygger prototyper og tester dem tidlig.',
          ],
        },
        { tag: 'h4', children: ['Lansere'] },
        {
          tag: 'p',
          children: [
            'Vi utvikler robuste, brukervennlige produkter med fokus på kvalitet og verdi.',
          ],
        },
        { tag: 'h4', children: ['Skalere'] },
        {
          tag: 'p',
          children: [
            'Vi måler, lærer og videreutvikler basert på faktisk bruk og tilbakemeldinger.',
          ],
        },
      ],
      title: 'Vår prosess',
    },
    {
      type: 'imageCarouselElement',
      images: [
        c.image('/public/val/bilde2_17336.webp', {
          width: 1600,
          height: 962,
          mimeType: 'image/webp',
        }),
        c.image('/public/val/bilde1_1661f.webp', {
          width: 2846,
          height: 1930,
          mimeType: 'image/webp',
        }),
        c.image('/public/val/img_7133_a57fd.jpg', {
          width: 1366,
          height: 2048,
          mimeType: 'image/jpeg',
        }),
        c.image('/public/val/img_7203_f4114.jpg', {
          width: 1366,
          height: 2048,
          mimeType: 'image/jpeg',
        }),
        c.image('/public/val/dscf2889_2_f0bc5.jpg', {
          width: 1664,
          height: 2496,
          mimeType: 'image/jpeg',
          hotspot: { x: 0.5540364583333334, y: 0.44 },
        }),
        c.image('/public/val/img_7288_94a12.jpg', {
          width: 1366,
          height: 2048,
          mimeType: 'image/jpeg',
        }),
      ],
    },
  ],
  pageMetadata: {
    title: 'Tjenester',
    description: 'Spesialister på å utvikle digitale produkter',
    url: '/tjenester',
    image: null,
  },
});
